import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Theme, ThemeService } from '../../services/theme.service';

@Component({
  selector: 'bepatient-logo-holder',
  templateUrl: './logo-holder.component.html',
  styleUrls: ['./logo-holder.component.scss'],
  standalone: false
})
export class LogoHolderComponent implements OnInit {
  private themeService = inject(ThemeService);

  Theme = Theme;
  lightLogoImg = 'instance-dyn/assets/images/b_research_logo.svg';
  darkLogoImg = 'instance-dyn/assets/images/b_research_logo_dark.svg';
  theme$: Observable<Theme>;

  constructor() {
    this.theme$ = this.themeService.getTheme();
  }

  ngOnInit(): void {}
}
